import { API_ENTITY_INFORMATION, FEATURES } from "@/constants";
import store from "@/store";

/**
 * The entity id to override session base pricing with, or `undefined` when the student-discount
 * flag is off or no domain entity is set.
 *
 * Gated by the same `display-student-discounts` flag that gates the special pricing override elsewhere
 * (read from the store the same way `hasDisplayStudentDiscountEnabled` derives it). On the backend this
 * maps to the `special_pricing_override_entity_id` query param on the session-detail reads, which selects
 * the institution override base price.
 *
 * Note: `domain_entity_id` is a separate, auth-only param and must not be used for pricing.
 */
export const specialPricingOverrideEntityId = () => {
  const flagEnabled = store?.state?.featureFlags?.[FEATURES.displayStudentDiscount];
  const domainEntityId = store?.getters?.getDomainEntityId;
  // The base API entity id is the storefront default, not an override — treat it as "no override"
  // (the Algolia cards normalize the same way via `domainEntityId !== API_ENTITY_INFORMATION.id`).
  if (!flagEnabled || !domainEntityId || domainEntityId === API_ENTITY_INFORMATION.id) {
    return undefined;
  }
  return domainEntityId;
};

/**
 * Convenience for spreading into a request params object so the override key is only present when
 * applicable, e.g. `getProgramSession({ id, ...specialPricingOverrideParam() })`.
 */
export const specialPricingOverrideParam = () => {
  const entityId = specialPricingOverrideEntityId();
  return entityId ? { special_pricing_override_entity_id: entityId } : {};
};
